export default __webpack_public_path__ + "public/images/home/presets/small-flat.png?89997ebf";